import React, { useEffect } from 'react';
import { Paper, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Downgraded, useState } from '@hookstate/core';
import TagDialog from '../../sharedcomponents/tagList/tagDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import CircularProgress from '@mui/material/CircularProgress';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import Helper from '../../utility/helper';
import DataList from '../../sharedcomponents/dataList/dataList';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import UserListDialog from '../Schedule/userListDialog';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const Tags = (props) =>
{
    const classes = useStyles();
    const setAll = useState(false);
    const tags = useState([]);
    const openDialog = useState(false);
    const eventTagInfo = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const loading = useState(false);
    const openAddParticipantDialog = useState(false);
    const isView = useState(false);
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const [addedTag, setAddedTag] =  React.useState('');
    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (Helper.isAdminUser(userInfo) || (userInfo.roles && Helper.isEventAdmin(userInfo))) {
            setModPermission(FULL_PERMISSION);
        }
        else {
            setModPermission(VIEW_PERMISSION);
        }
        getTagsData()
    }, [])

    const getTagsData = () =>
    {
        loading.set(true);
        const geventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(APIURLConstants.GET_EVENT_TAGS(geventInfo.eventID))
            .then((res) =>
            {
                if (res.data.tags)
                { 
                    loading.set(false);
                    let tagsData = [];
                    if (res.data.tags.length > 0)
                    {
                        res.data.tags.map((item) =>
                        {
                            tagsData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'tagID',
                                        tagID: item.tagID,
                                        width: '0.1',
                                    },
                                    {
                                        label: 'Name',
                                        key: 'tagName',
                                        tagName: item.tagName,
                                        width: '0.6',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status: item.status
                                            ? 'Active'
                                            : 'Inactive',
                                        width: '0.2',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'addParticipants',
                                        addParticipants: 'Add Participants',
                                        width: '0.02',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'participants',
                                        participants: 'Participants',
                                        count: item.tagParticipant && item.tagParticipant.length,
                                        width: '0.02',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.1',
                                    },
                                ],
                                selected: false,
                            });
                        });
                    }
                    tags.set(tagsData);
                    overallParticipants.set(res.data.tagParticipant);
                }
            })
            .catch((err) =>
            {
                loading.set(false);
                if (err.response && err.response.status === 401)
                {
                    console.log(err);
                }
            });
    }

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    // const selectAll = (event) => {
    //     setAll.set(event.target.checked);
    //     let newUsers = tags.attach(Downgraded).get();
    //     newUsers.map((item) => (item['selected'] = event.target.checked));
    //     console.log('newUsers : ', newUsers);
    //     tags.set(newUsers);
    // };

    const redirectToCreate = () =>
    {
        openDialog.set(true);
    };

    const handleClose = () =>
    {
        eventTagInfo.set(null);
        openDialog.set(false);
    };

    const editTag = (tagInfo) =>
    {
        eventTagInfo.set(tagInfo.actualData);
        openDialog.set(true);
    };


    // const onCheckSelect = (event, index) => {
    //     let newTags = tags.attach(Downgraded).get();
    //     newTags[index]['selected'] = event.target.checked;
    //     const checkAll = newTags.every((obj) => obj.selected === true);
    //     setAll.set(checkAll);
    //     tags.set(newTags);
    // };

    const deleteTags = () =>
    {
        const selected = tags.get().filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select tags first',
            });
        } else
        {
            let message = selected.length == tags.get().length
                ? 'Do you want to delete all tags ?'
                : 'Do you want to delete selected tags ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleConfirmation = () =>
    {
        let deleteTags = [];
        tags.get().map((user) =>
        {
            if (user.selected === true)
            {
                deleteTags.push(user.actualData.tagID);
            }
        });

        ApiHelper.post(APIURLConstants.POST_DELETE_TAG, {
            ids: deleteTags.join(','),
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Tags deleted successfully',
                    });
                    setShowSearchRec(false);
                    setAll.set(false)
                    getTagsData();
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting tags';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const addParticipants = (selectedUsers) => {
        // console.log("selectedUsers",selectedUsers);
        const userInfo = Helper.getStorage('userInfo');
        const geventInfo = Helper.getStorage('eventInfo');

        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let requestObj = {
                participants: [],
                userTags: addedTag.toString(),
            };
            let users = selectedUsers;
            users.forEach((item) => {
                requestObj.participants.push({
                    eventUsersID: 0,
                    eventID: geventInfo.eventID,
                    userID: item,
                    roleID: 0,
                    createdBy: userInfo.userID,
                });
            });
            ApiHelper.post(APIURLConstants.POST_EVENT_PARTICIPANTS, requestObj)
                .then((res) => { 
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully.',
                        });     
                        getTagsData()                    
                        openAddParticipantDialog.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };
    const deleteParticipants = (selectedUsers) => {
        const userInfo = Helper.getStorage('userInfo');

        const filterParticipant = filteredParticipants.attach(Downgraded).get(); 
        let eventUserIds = filterParticipant && filterParticipant.length > 0 && filterParticipant.filter((x) => selectedUsers.includes(x.userID))

        let ids = []
        eventUserIds && eventUserIds.map((val) => {
            ids.push(val.eventUsersID)
        })
        // console.log("filteredParticipants",filterParticipant, eventUserIds,selectedUsers);

        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            ApiHelper.post(APIURLConstants.DELETE_EVENT_PARTICIPANTS_FROM_TAG, {
                Ids: ids.join(','),
                tagID: Number(addedTag),
                CreatedBy: userInfo.userID,
            })
                .then((res) =>
                {
                    if (res.data)
                    {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants deleted successfully.',
                        });              
                        getTagsData()                             
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };
    const handleCloseAddParticipant = () => {
        // console.log("close dialog");
        openAddParticipantDialog.set(false);
        isView.set(false);
        setAddedTag('')
    };
    const handleAddParticipants = (participant) => {
        // console.log("participant",participant);
        setAddedTag(participant.actualData.tagID)
                let ids = participant.actualData.tagParticipant && participant.actualData.tagParticipant.map((x) => x.userID);
                let newParticipants = []
                let allParticipants = overallParticipants
                    .attach(Downgraded)
                    .get();
                    allParticipants.map((val) => {
                        val.userTags = val.tagName
                        newParticipants.push(val) 
                    })
                    console.log("allParticipants",allParticipants,newParticipants);
                let userList = newParticipants.filter(
                    (x) => !ids.includes(x.userID)
                );
                // console.log("userList",userList);
                filteredParticipants.set(userList);
                openAddParticipantDialog.set(true);
          
    };
    const handleViewParticipants = (participant) => {
        isView.set(true);
        setAddedTag(participant.actualData.tagID)
        let newParticipants = []

        participant.actualData.tagParticipant && participant.actualData.tagParticipant.length > 0 && participant.actualData.tagParticipant.map((val) => {
            val.userTags = val.tagName
            newParticipants.push(val)
        })
        filteredParticipants.set(newParticipants);
        openAddParticipantDialog.set(true);
    };
    return (
        <>
            {loading.get() ? (
                <Box sx={loading.get() ? { paddingTop: '20%', paddingBottom: '20%' } : ''} className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) :
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none',overflowY:'auto',maxHeight:'calc(100vh - 70px)', paddingLeft: '4px', paddingRight: '8px' }}>
                    {tags.get() ? (
                        <DataList
                            data={tags.attach(Downgraded).get()}
                            // onCheckSelect={onCheckSelect}
                            editRow={editTag}
                            handleClick={redirectToCreate}
                            title={''}
                            buttonTitle={'Add'}
                            deleteRows={deleteTags}
                            showSearch={true}
                            searchLabel={'Search'}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            modPermission={modPermission}
                            handleAddParticipants={handleAddParticipants}
                            handleViewParticipants={handleViewParticipants}
                            label={'Tags'}    
                        />
                    ) : null}
                    {openDialog.get() && (
                        <TagDialog
                            open={openDialog.get()}
                            title={eventTagInfo.get() ? "Edit Tag" : "Add Tag"}
                            eventTagInfo={eventTagInfo.attach(Downgraded).get()}
                            handleClose={handleClose}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getTagsData={getTagsData}
                            allTags={tags.attach(Downgraded).get()}
                        />
                    )}
                    {openAddParticipantDialog.get() && (
                        <UserListDialog
                            title={
                                !isView.get() ? 'ADD PARTICIPANTS' : 'VIEW PARTICIPANTS'
                            }
                            addParticipants={addParticipants}
                            open={openAddParticipantDialog.get()}
                            deleteParticipants={deleteParticipants}
                            handleClose={handleCloseAddParticipant}
                            users={filteredParticipants.attach(Downgraded).get()}
                            isView={isView.get()}
                            selectAllCheckBox={true}
                        />
                    )}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() =>
                            {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({ ...snackBarProps, openSnack: false })
                            }></CustomizedSnackbars>
                    )}
                </Paper>
            }
        </>
    );
};

export default Tags;
